module.exports = __webpack_public_path__ + "static/media/Icon-back.6668759e.svg";